type MaybeClockDrift = { clockDriftSteps?: unknown };
type WithClockDrift = { clockDriftSteps: number };

const hasClockDrift = <T extends MaybeClockDrift>(
  response: T,
): response is T & WithClockDrift => (
  typeof response.clockDriftSteps === 'number' && response.clockDriftSteps > 0
);

export default hasClockDrift;
